import React, { Component } from 'react';
import { Bind } from 'lodash-decorators/bind';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

//store
import EnterprisesStore from 'stores/Enterprises.store';

//styles
import styles from './CSRView.module.scss';

import messages from './CSRView.intl';

//components
import { CONTACT } from 'common/consts/common';
import { STATIC_TAXONOMY } from 'common/consts/staticTaxonomy';
import { Container, Title } from 'common/components/Layout/Layout';
import ImageGreyBackground from 'common/components/ImageGreyBackground/ImageGreyBackground';
import Filters from 'common/components/Filters/Filters';
import GroupTile from './components/GroupTile/GroupTile';
import GroupCard from './components/GroupCard/GroupCard';

import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import Placeholder from 'common/components/Placeholder/Placeholder';
import FullWidthBackground from 'common/components/Placeholder/components/FullWidthBackground/FullWidthBackground';

@injectIntl
@observer
export default class CSRView extends Component {
  constructor(props) {
    super(props);

    this.filtersList = [
      {
        text: this.props.intl.formatMessage(messages.taxonomyAll),
        value: [
          STATIC_TAXONOMY.GROUP.values.IT,
          STATIC_TAXONOMY.GROUP.values.OTHER
        ]
      },
      {
        text: this.props.intl.formatMessage(messages.taxonomyIT),
        value: STATIC_TAXONOMY.GROUP.values.IT
      },
      {
        text: this.props.intl.formatMessage(messages.taxonomyOther),
        value: STATIC_TAXONOMY.GROUP.values.OTHER
      }
    ];

    this.state = {
      activeEnterprise: null,
      activeFilter: this.filtersList[0]
    };
  }

  componentDidMount() {
    EnterprisesStore.getEnterprises();
  }

  render() {
    const { activeFilter } = this.state;
    const enterprises = EnterprisesStore.getEnterprisesByType(
      activeFilter.value
    );
    const firstEnterprise = enterprises.length ? enterprises[0] : null;
    const activeEnterprise = this.state.activeEnterprise || firstEnterprise;
    const content = ContentStore.content;

    return (
      <div className={styles.CSR}>
        {ContentStore.isLoaded && <InjectMetaTags {...content.csrSEO} />}
        <Container className={styles.CSRHeader}>
          <Title title="CSR" className={styles.Header} />
          <Filters
            filters={this.filtersList}
            activeFilter={activeFilter}
            onSelect={this.handleFilterChange}
            className={styles.Filters}
          />
        </Container>

        <Placeholder component={<FullWidthBackground />} ready={!!content}>
          {content && (
            <ImageGreyBackground
              className={styles.BoldHeading}
              source={content.csrImage}
              alternative="hello"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: content.csrText
                }}
              />
            </ImageGreyBackground>
          )}
        </Placeholder>

        <Container className={styles.GroupIconsContainer}>
          <div className={styles.Icons}>
            {enterprises.length ? (
              enterprises.map((enterpriseItem, index) => (
                <GroupTile
                  key={index}
                  enterprise={enterpriseItem}
                  onClick={this.setActiveEnterprise}
                  className={
                    index % 2 === 0 ? styles.TileWhite : styles.TileGrey
                  }
                />
              ))
            ) : (
              <div>
                {this.props.intl.formatMessage(messages.nothingWasFound)}
              </div>
            )}
          </div>
          <div className={styles.Contact}>
            <div className={styles.ContactContainer}>
              <h4 className={styles.ContactText}>
                {this.props.intl.formatMessage(messages.header)}
              </h4>
            </div>
            <div className={styles.ContactContainer}>
              <h4 className={`${styles.ContactText} ${styles.Blue}`}>
                <a
                  href={`mailto:${CONTACT.EVENT}`}
                  className={styles.ContactMail}
                >
                  {this.props.intl.formatMessage(messages.buttonText)}
                </a>
              </h4>
            </div>
          </div>
        </Container>
        {activeEnterprise && (
          <Container>{<GroupCard enterprise={activeEnterprise} />}</Container>
        )}
      </div>
    );
  }

  @Bind()
  setActiveEnterprise(enterprise) {
    this.setState({
      activeEnterprise: enterprise
    });
  }

  @Bind()
  handleFilterChange(value) {
    this.setState({
      activeFilter: value,
      activeEnterprise: null
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/CSR/CSRView.js